import styled from "styled-components";

export const MaterialIcons = styled.span<{ color?: string }>`
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;

    font-size: 16px;
    color: ${({ color }) => color || "#009157"};
`;

export const OperationItem = styled.label`
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    background: #f8f9fa;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;

    .selected {
        border: 1px solid #2196f3;
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
        transform: translateY(-2px);
        background: #fafbff;
    }
`;

export const OperationAmount = styled.span`
    position: absolute;
    top: -10px;
    right: -10px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: #f00;
`;

export const OperationContent = styled.div`
    display: flex;
    gap: 12px;
    flex: 1;
`;

export const OperationDetails = styled.div`
    flex: 1;
`;

export const OperationName = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #424242;
    margin-bottom: 2px;
`;

export const OperationMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
`;

export const MetaItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #757575;
`;

export const OperationTags = styled.div`
    display: flex;
    gap: 8px;
`;

export const OperationTagsOperations = styled.span`
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;

    background: #e3f2fd;
    color: #1976d2;
`;

export const OperationTagsTalhoes = styled(OperationTagsOperations)`
    background: #e3f2fd;
    color: #1976d2;
`;
